import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgUpgradeColored = (props, ref) => /* @__PURE__ */ jsxs("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", ref, ...props, children: [
  /* @__PURE__ */ jsx("rect", { width: 20, height: 20, rx: 10, fill: "#521EC9" }),
  /* @__PURE__ */ jsx("path", { d: "M10 3.875L16.0622 9.125H3.93782L10 3.875Z", fill: "white" }),
  /* @__PURE__ */ jsx("rect", { x: 6.49902, y: 8.25, width: 7, height: 3.5, fill: "white" }),
  /* @__PURE__ */ jsx("rect", { x: 6.49902, y: 12.625, width: 7, height: 0.875, fill: "white" }),
  /* @__PURE__ */ jsx("rect", { x: 6.49902, y: 14.375, width: 7, height: 0.874999, fill: "white" })
] });
const ForwardRef = forwardRef(SvgUpgradeColored);
export default ForwardRef;
